/*
 * FROSTBEULE – exit popup (owner: CHROME). Loaded with defer by sections/frost-exit-popup.liquid.
 * <fb-exit-popup data-section-id data-delay>
 *   Desktop only: fine pointer + hover and ≥ 750 px wide. Opens when the pointer leaves the viewport
 *   at the top after ≥ data-delay seconds on the page.
 *   Once per session: sessionStorage 'fb-exit-shown' (try/catch → memory = once per page view).
 *   Never while the age gate is open, never while another dialog is open, never in a hidden tab.
 *   Theme editor: opens only while the section is selected (shopify:section:select / deselect).
 *   Dialog: focus trap + Esc via FROSTBEULE.focusTrap, scroll lock, focus returns on close.
 */
(function () {
  'use strict';

  if (window.__fbExitPopupLoaded) return;
  window.__fbExitPopupLoaded = true;

  var doc = document;
  var root = doc.documentElement;
  var KEY = 'fb-exit-shown';
  var shownInMemory = false;
  var selectedSection = null;

  function C() {
    return window.FROSTBEULE || {};
  }

  function motion() {
    var c = C();
    return typeof c.motion === 'function' ? c.motion() : root.getAttribute('data-motion') || 'full';
  }

  function designMode() {
    return !!(window.Shopify && window.Shopify.designMode);
  }

  function alreadyShown() {
    if (shownInMemory) return true;
    try {
      return window.sessionStorage.getItem(KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function markShown() {
    shownInMemory = true;
    try {
      window.sessionStorage.setItem(KEY, '1');
    } catch (e) {}
  }

  function ageGateOpen() {
    if (C().ageGateOpen) return true;
    return root.classList.contains('fb-age-pending') && !root.classList.contains('fb-age-failsafe');
  }

  function otherDialogOpen() {
    return (
      root.classList.contains('fb-scroll-locked') ||
      doc.body.classList.contains('overflow-hidden') ||
      !!doc.querySelector('cart-drawer.active, .fb-drawer.is-open, [aria-modal="true"].is-open')
    );
  }

  function isDesktop() {
    try {
      return window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 750px)').matches;
    } catch (e) {
      return false;
    }
  }

  function findPopup(sectionId) {
    return doc.querySelector('fb-exit-popup[data-section-id="' + sectionId + '"]');
  }

  /* Theme editor: preview only while the section is selected */
  doc.addEventListener('shopify:section:select', function (e) {
    selectedSection = e.detail && e.detail.sectionId;
    var popup = findPopup(selectedSection);
    if (popup && typeof popup.open === 'function') popup.open({ preview: true });
  });
  doc.addEventListener('shopify:section:deselect', function (e) {
    var id = e.detail && e.detail.sectionId;
    if (id === selectedSection) selectedSection = null;
    var popup = findPopup(id);
    if (popup && typeof popup.close === 'function') popup.close();
  });

  if (customElements.get('fb-exit-popup')) return;

  customElements.define(
    'fb-exit-popup',
    class FbExitPopup extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.sectionId = this.getAttribute('data-section-id');
        this.dialog = this.querySelector('.fb-exit__dialog');
        this.isOpen = false;
        this.delay = Math.max(0, parseFloat(this.getAttribute('data-delay')) || 8) * 1000;

        this.onClick = function (e) {
          if (e.target.closest('[data-fb-exit-close]')) {
            self.close();
            return;
          }
          /* in-page anchor (e.g. CTA → #fb-kup on the product page): close first, so the scroll lock
             is released before the browser jumps to the target */
          var link = e.target.closest('a[href^="#"]');
          if (link && link.getAttribute('href').length > 1) self.close(false);
        };
        this.addEventListener('click', this.onClick);

        if (designMode()) {
          if (selectedSection === this.sectionId) this.open({ preview: true, instant: true });
          return;
        }
        if (alreadyShown() || !isDesktop()) return;
        this.arm();
      }

      disconnectedCallback() {
        this.disarm();
        clearTimeout(this.hideTimer);
        if (this.openRaf) window.cancelAnimationFrame(this.openRaf);
        this.openRaf = 0;
        if (this.isOpen) {
          this.isOpen = false;
          if (C().unlockScroll) C().unlockScroll();
          if (this.trap) this.trap.release(false);
        }
      }

      arm() {
        var self = this;
        this.armedAt = Date.now();
        /* time on the page counts from the age confirmation, not from the gate */
        this.onAgeVerified = function () {
          self.armedAt = Date.now();
        };
        doc.addEventListener('frost:age-verified', this.onAgeVerified);

        this.onMouseOut = function (e) {
          if (e.relatedTarget || e.toElement) return;
          if (e.clientY > 0) return;
          if (Date.now() - self.armedAt < self.delay) return;
          self.trigger();
        };
        doc.addEventListener('mouseout', this.onMouseOut);
      }

      disarm() {
        if (this.onMouseOut) doc.removeEventListener('mouseout', this.onMouseOut);
        if (this.onAgeVerified) doc.removeEventListener('frost:age-verified', this.onAgeVerified);
        this.onMouseOut = this.onAgeVerified = null;
      }

      trigger() {
        if (this.isOpen || ageGateOpen() || otherDialogOpen() || doc.hidden) return;
        if (alreadyShown()) {
          this.disarm();
          return;
        }
        this.disarm();
        markShown();
        this.open();
      }

      open(opts) {
        var self = this;
        opts = opts || {};
        if (this.isOpen) return;
        this.isOpen = true;
        clearTimeout(this.hideTimer);
        this.hidden = false;

        if (this.openRaf) window.cancelAnimationFrame(this.openRaf);
        this.openRaf = 0;
        if (opts.instant || motion() === 'none') {
          this.classList.add('is-open');
        } else {
          void this.offsetWidth;
          /* next frame → the enter transition runs; skipped if close() came first */
          this.openRaf = window.requestAnimationFrame(function () {
            self.openRaf = 0;
            if (self.isOpen) self.classList.add('is-open');
          });
        }

        if (C().lockScroll) C().lockScroll();
        /* the dialog itself takes focus (labelled by the heading); no ring flashes on the CTA */
        var initial = this.dialog;
        if (C().focusTrap) {
          this.trap = C().focusTrap(this.dialog, {
            initialFocus: initial,
            onEscape: function () {
              self.close();
            },
          });
        } else {
          this.onKey = function (e) {
            if (e.key === 'Escape' || e.key === 'Esc') self.close();
          };
          doc.addEventListener('keydown', this.onKey);
          this.previousFocus = doc.activeElement;
          try {
            initial.focus({ preventScroll: true });
          } catch (e) {
            initial.focus();
          }
          this.trap = {
            release: function (returnFocus) {
              doc.removeEventListener('keydown', self.onKey);
              if (returnFocus !== false && self.previousFocus && self.previousFocus.focus) self.previousFocus.focus();
            },
          };
        }
      }

      close(returnFocus) {
        var self = this;
        if (!this.isOpen) return;
        this.isOpen = false;
        if (this.openRaf) window.cancelAnimationFrame(this.openRaf);
        this.openRaf = 0;
        this.classList.remove('is-open');
        if (C().unlockScroll) C().unlockScroll();
        if (this.trap) this.trap.release(returnFocus !== false);
        this.trap = null;
        clearTimeout(this.hideTimer);
        this.hideTimer = setTimeout(
          function () {
            if (!self.isOpen) self.hidden = true;
          },
          motion() === 'none' ? 0 : 260
        );
      }
    }
  );
})();
